import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from 'vuex-module-decorators';

import FormsApi from '@/api/forms';
import { initialUnencryptedStorage } from '@/globals';
import store from '@/store';

const name = 'form';

@Module({
  namespaced: true,
  name,
  dynamic: true, // important!
  store, // module is dynamically added to the store here (so after the store was created, instead of during the creation)
  preserveState: Boolean(initialUnencryptedStorage[name]) // preserve state when available from local storage, else don't preserve
})
class FormModule extends VuexModule {
  // state
  store: typeof store;
  formStores: FormStore[] = [];

  // mutations
  @Mutation
  setFormStores(formStores) {
    this.formStores = formStores;
  }

  // actions
  @Action({ commit: 'setFormStores', rawError: true })
  async getFormStores() {
    return FormsApi.getFormStores();
  }

  @Action({ rawError: true })
  async submitContactUs(request: ContactUsRequest) {
    return FormsApi.submitContactUs(request);
  }

  @Action({ rawError: true })
  async submitGiftCardBalanceCheck(request: GiftCardBalanceCheckRequest): Promise<number> {
    return FormsApi.submitGiftCardBalanceCheck(request);
  }

  @Action({ rawError: true })
  async submitFoundationApplication(request: FoundationApplicationRequest) {
    return FormsApi.submitFoundationApplication(request);
  }

  @Action({ rawError: true })
  async submitFreeSubs(request: FreeSubsRequest) {
    return FormsApi.submitFreeSubs(request);
  }

  @Action({ rawError: true })
  async submitSweepstakes(request: SweepstakesRequest) {
    return FormsApi.submitSweepstakes(request);
  }

  @Action({ rawError: true })
  async submitWSA(request: WSARequest) {
    return FormsApi.submitWSA(request);
  }
}
export default getModule(FormModule);
